import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const ACCENT_COLOR = '#94A3FF';

const TextDocumentIcon: React.FC<CommonIconProps> = ({
  svgProps,
  ...restProps
}: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.XXL}
      {...restProps}
      svgProps={{
        viewBox: '0 0 40 40',
        ...svgProps
      }}
    >
      <path
        d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
        fill="currentColor"
      />
      <path
        d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
        fill={ACCENT_COLOR}
        opacity="0.3"
      />
      <rect
        x="10"
        y="20"
        width="20"
        height="2"
        rx="1"
        fill={ACCENT_COLOR}
        opacity="0.5"
      />
      <rect
        x="10"
        y="26"
        width="20"
        height="2"
        rx="1"
        fill={ACCENT_COLOR}
        opacity="0.5"
      />
      <rect
        x="10"
        y="32"
        width="13"
        height="2"
        rx="1"
        fill={ACCENT_COLOR}
        opacity="0.5"
      />
    </BaseIcon>
  );
};

export default TextDocumentIcon;
